// @ts-nocheck
import React, { memo, useState, useCallback } from 'react';
import { Handle, Position, NodeResizer } from 'reactflow';
import { apiPatch } from '../../../utils/apiClient';
import { logger } from '../../../utils/logger';
import type { PDFSnippetNodeProps } from '../../../types/canvas';
import './PDFSnippetNode.css';

/**
 * PDF 片段节点
 * 显示从 PDF 中选中的文本片段，支持双击编辑
 */
const PDFSnippetNode: React.FC<PDFSnippetNodeProps> = ({ data, selected }) => {
  const { text, page } = data.content || {};
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState(text || '');

  const handleDoubleClick = useCallback(() => {
    setIsEditing(true);
    setEditText(text || '');
  }, [text]);

  const handleBlur = useCallback(async () => {
    setIsEditing(false);
    if (editText !== text) {
      try {
        await apiPatch(`/api/blocks/${data.blockId}`, {
          content: {
            ...data.content,
            text: editText
          }
        });
        logger.log('✅ PDF片段已更新');
      } catch (err) {
        console.error('❌ 更新PDF片段失败:', err);
        setEditText(text || '');
      }
    }
  }, [editText, text, data]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      (e.target as HTMLTextAreaElement).blur();
    }
    if (e.key === 'Escape') {
      setEditText(text || '');
      setIsEditing(false);
    }
  }, [text]);

  return (
    <div className={`pdf-snippet-node ${selected ? 'selected' : ''}`}>
      <NodeResizer
        color="#1a73e8"
        isVisible={selected}
        minWidth={200}
        minHeight={120}
      />
      <Handle type="target" position={Position.Top} className="node-handle" />

      <div className="node-header pdf-snippet-header">
        <span className="node-icon">📄</span>
        <span className="node-title">PDF 片段</span>
        <span className="page-badge">P{page || '?'}</span>
      </div>

      <div className="node-content" onDoubleClick={handleDoubleClick}>
        {isEditing ? (
          <textarea
            className="snippet-textarea"
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        ) : (
          <p className="snippet-text">{text || '双击编辑文本...'}</p>
        )}
      </div>

      <div className="node-footer">
        <span className="node-type-label">PDF Snippet</span>
      </div>

      <Handle type="source" position={Position.Bottom} className="node-handle" />
    </div>
  );
};

export default memo(PDFSnippetNode);
